import { Pipe, PipeTransform } from '@angular/core';

/**
 * This pipe returns the value of a chained property from an object
 * Eg:
 *  transform(obj, 'foo.bar')
 * Having in obj
 *   obj = { foo: { bar: 3 } }
 * It will return '3'
 */
@Pipe({
    name: 'resolveProperty',
    standalone: false,
})
export class ResolvePropertyPipe implements PipeTransform {
    /**
     * Gets a property's value from a defined object. It can get it from chained properties
     * @param obj Object where we want to obtain a property's value
     * @param propertyPath String with the property to obtain. It can be chained, like 'foo.bar'
     * @returns
     */
    transform(obj: any, propertyPath: string): any {
        if (!propertyPath) {
            return '';
        }

        return this.resolve(obj, propertyPath);
    }

    private resolve(obj: any, propertyPath: string): any {
        return propertyPath.split('.').reduce((prev: any, curr: any) => {
            return prev ? prev[curr] : null;
        }, obj || self);
    }
}
